import {
  getRouteSearchParams,
  getRoute,
} from 'tickets/redux/modules/router/selectors'
import { getTicketsPath } from 'tickets/utils/urlUtils'
import { stringify } from 'common/utils/urlUtils'
import { getLanguageCode } from 'tickets/redux/modules/user/selectors'
import history from 'common/utils/history'
import { convertToModeId } from 'tickets/utils/modes'
import {
  NO_RESULTS_MODE,
} from 'tickets/utils/constants'

const getCurrentParams = (getState) => {
  const state = getState()
  const languageCode = getLanguageCode(state)
  const route = getRoute(state)
  return ({
    routeSearchParams: getRouteSearchParams(state),
    path: getTicketsPath(
      languageCode,
      route.origin,
      route.destination
    ),
  })
}

const outboundTicketSelected = (ticketID) => (dispatch, getState) => {
  const currentParams = getCurrentParams(getState)
  const newParams = stringify({
    ...currentParams.routeSearchParams,
    oid: ticketID,
  })
  history.push(`${currentParams.path}?${newParams}`)
}

const inboundTicketSelected = (ticketID) => (dispatch, getState) => {
  const currentParams = getCurrentParams(getState)
  const newParams = stringify({
    ...currentParams.routeSearchParams,
    iid: ticketID,
  }, { encode: false })
  history.push(`${currentParams.path}?${newParams}`)
}

const clearResults = () => (dispatch, getState) => {
  const currentParams = getCurrentParams(getState)
  const newParams = {
    ...currentParams.routeSearchParams,
  }
  if (newParams.oid) {
    delete newParams.oid
  }
  if (newParams.iid) {
    delete newParams.iid
  }
  history.push(`${currentParams.path}?${stringify(newParams)}`)
}

const inboundTicketRemoved = () => (dispatch, getState) => {
  const currentParams = getCurrentParams(getState)
  const newParams = {
    ...currentParams.routeSearchParams,
  }
  if (newParams.iid) {
    delete newParams.iid
  }
  history.push(`${currentParams.path}?${stringify(newParams)}`)
}

const updateModeId = (modeID, replace = false) => (dispatch, getState) => {
  const currentParams = getCurrentParams(getState)
  const newParams = {
    ...currentParams.routeSearchParams,
    mode: (modeID == NO_RESULTS_MODE) ? NO_RESULTS_MODE : convertToModeId(modeID),
  }

  const newURL = `${currentParams.path}?${stringify(newParams)}`

  if (replace) {
    history.replace(newURL)
  } else {
    history.push(newURL)
  }
}

export default {
  clearResults,
  outboundTicketSelected,
  inboundTicketSelected,
  inboundTicketRemoved,
  updateModeId,
  getCurrentParams,
}
